// extracted by mini-css-extract-plugin
var _1 = "LoginPasswordFormView-module__animateUploadProgressBarWidth--TWXQT";
var _2 = "LoginPasswordFormView-module__animatedBackground--hIcBM";
var _3 = "LoginPasswordFormView-module__forgotLink--_6rJ4";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "forgotLink" }
